<div class="chat-root w-100" [class.has-conversation]="hasConversation">
  <!-- Initial state: input at top -->
  @if (!hasConversation) {
    <div class="content-container w-90">
      <div class="prompt-input-container mt-2" [class.is-expanded]="isPromptExpanded">
        <textarea
          class="prompt-input"
          rows="1"
          wrap="soft"
          #promptInput
          [disabled]="disabled || isStreaming || modelSelectionLoading"
          aria-multiline="true"
          (input)="onInputChange($event)"
          (keydown)="onComposerKeydown($event)"
          ></textarea>
        @if (!currentPrompt) {
          <span class="prompt-placeholder">{{ placeholder }}</span>
        }
        <button class="send-button" type="button" aria-label="Send" (click)="onSend()" [disabled]="disabled || isStreaming || modelSelectionLoading">
          <i class="bi bi-send-fill"></i>
        </button>
      </div>
      <div class="chat-actions mt-2">
        <div class="chat-actions-left">
          <button class="icon-button" type="button" aria-label="View/Edit Context" ngbTooltip="View/Edit Context" [placement]="hasConversation ? 'top' : 'bottom'" (click)="openContextModal()">
            <i class="bi bi-braces"></i>
          </button>
          <button class="icon-button" type="button" aria-label="Attach files" ngbTooltip="Attach files" [placement]="hasConversation ? 'top' : 'bottom'" (click)="fileInput.click()">
            <i class="bi bi-paperclip"></i>
          </button>
          <button class="icon-button" type="button" aria-label="Voice input" ngbTooltip="Voice input" [placement]="hasConversation ? 'top' : 'bottom'" (click)="onVoiceInputToggle()">
            <i class="bi bi-mic"></i>
          </button>
          <button class="icon-button" type="button" aria-label="Regenerate last reply" ngbTooltip="Regenerate last reply" [placement]="hasConversation ? 'top' : 'bottom'" (click)="onRegenerate()">
            <i class="bi bi-arrow-repeat"></i>
          </button>
          <button class="icon-button" type="button" aria-label="Stop" ngbTooltip="Stop" [placement]="hasConversation ? 'top' : 'bottom'" (click)="onStop()">
            <i class="bi bi-stop-circle"></i>
          </button>
          <button class="icon-button" type="button" aria-label="Clear conversation" ngbTooltip="Clear conversation" [placement]="hasConversation ? 'top' : 'bottom'" (click)="onClear()">
            <i class="bi bi-eraser"></i>
          </button>
          <input type="file" #fileInput multiple (change)="onFilesSelected($event)" style="display:none" />
        </div>
        <div class="chat-actions-right">
          @if (lastModelIndicator) {
            <div class="model-used-indicator small" [attr.title]="lastModelIndicator">{{ lastModelIndicator }}</div>
          }
          <select
            class="model-select"
            [disabled]="disabled || isStreaming || modelSelectionLoading"
            [value]="modelSelectionLoading ? '' : selectedModelId"
            (change)="onModelChange(($any($event.target).value))"
            ngbTooltip="Model"
            [placement]="hasConversation ? 'top' : 'bottom'"
            aria-label="Select model"
          >
            @if (modelSelectionLoading) {
              <option value="">Loading model...</option>
            }
            @for (m of modelOptions; track m.id) {
              <option [value]="m.id">{{ m.label }}</option>
            }
          </select>
          <app-prompt-analyser [text]="currentPrompt" [tooltipPlacement]="hasConversation ? 'top' : 'bottom'"></app-prompt-analyser>
        </div>
      </div>
    </div>
  }

  <!-- Conversation: messages at top -->
  @if (hasConversation) {
    <div class="messages-container w-90 mb-4 pb-4" #messagesContainer>
      @for (m of messages; track $index; let i = $index) {
        <div class="message-row" [class.from-user]="m.role === 'user'" [class.from-assistant]="m.role === 'assistant'">
          <div class="message-bubble">
            @if (m.role === 'assistant' && isStreaming && i === messages.length - 1) {
              <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            }
            {{ m.text }}
          </div>
        </div>
      }
    </div>
  }

  <!-- Composer at bottom once conversation starts -->
  @if (hasConversation) {
    <div class="content-container w-90" [class.composer]="hasConversation">
      <div class="prompt-input-container mt-2 mb-4" [class.is-expanded]="isPromptExpanded">
        <textarea
          class="prompt-input"
          rows="1"
          wrap="soft"
          #promptInput
          [disabled]="disabled || isStreaming || modelSelectionLoading"
          aria-multiline="true"
          (input)="onInputChange($event)"
          (keydown)="onComposerKeydown($event)"
          ></textarea>
        @if (!currentPrompt) {
          <span class="prompt-placeholder">{{ placeholder }}</span>
        }
        <button class="send-button" type="button" aria-label="Send" (click)="onSend()" [disabled]="disabled || isStreaming || modelSelectionLoading">
          <i class="bi bi-send-fill"></i>
        </button>
      </div>
      <div class="chat-actions mb-2">
        <div class="chat-actions-left">
          <button class="icon-button" type="button" aria-label="View/Edit Context" ngbTooltip="View/Edit Context" [placement]="hasConversation ? 'top' : 'bottom'" (click)="openContextModal()">
            <i class="bi bi-braces"></i>
          </button>
          <button class="icon-button" type="button" aria-label="Attach files" ngbTooltip="Attach files" [placement]="hasConversation ? 'top' : 'bottom'" (click)="fileInput2.click()">
            <i class="bi bi-paperclip"></i>
          </button>
          <button class="icon-button" type="button" aria-label="Voice input" ngbTooltip="Voice input" [placement]="hasConversation ? 'top' : 'bottom'" (click)="onVoiceInputToggle()">
            <i class="bi bi-mic"></i>
          </button>
          <button class="icon-button" type="button" aria-label="Regenerate last reply" ngbTooltip="Regenerate last reply" [placement]="hasConversation ? 'top' : 'bottom'" (click)="onRegenerate()">
            <i class="bi bi-arrow-repeat"></i>
          </button>
          <button class="icon-button" type="button" aria-label="Stop" ngbTooltip="Stop" [placement]="hasConversation ? 'top' : 'bottom'" (click)="onStop()" [disabled]="!isStreaming">
            <i class="bi bi-stop-circle"></i>
          </button>
          <button class="icon-button" type="button" aria-label="Clear conversation" ngbTooltip="Clear conversation" [placement]="hasConversation ? 'top' : 'bottom'" (click)="onClear()">
            <i class="bi bi-eraser"></i>
          </button>
          <input type="file" #fileInput2 multiple (change)="onFilesSelected($event)" style="display:none" />
        </div>
        <div class="chat-actions-right">
          @if (isStreaming) {
            <div class="small text-muted d-flex align-items-center gap-2">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              <span>Generating…</span>
            </div>
          }
          @if (lastModelIndicator) {
            <div class="model-used-indicator small" [attr.title]="lastModelIndicator">{{ lastModelIndicator }}</div>
          }
          <select
            class="model-select"
            [disabled]="disabled || isStreaming || modelSelectionLoading"
            [value]="modelSelectionLoading ? '' : selectedModelId"
            (change)="onModelChange(($any($event.target).value))"
            ngbTooltip="Model"
            [placement]="hasConversation ? 'top' : 'bottom'"
            aria-label="Select model"
          >
            @if (modelSelectionLoading) {
              <option value="">Loading model...</option>
            }
            @for (m of modelOptions; track m.id) {
              <option [value]="m.id">{{ m.label }}</option>
            }
          </select>
          <app-prompt-analyser [text]="currentPrompt" [tooltipPlacement]="hasConversation ? 'top' : 'bottom'"></app-prompt-analyser>
        </div>
      </div>
    </div>
  }

  <!-- Suggestions only before conversation starts -->
  @if (!hasConversation) {
    <div class="suggestions-container">
      @for (suggestion of suggestions; track suggestion.prompt) {
        <div class="suggestion-item small" (click)="onSuggestionClick(suggestion)">
          <i class="bi" [class]="suggestion.icon"></i>
          <span>{{ suggestion.prompt }}</span>
        </div>
      }
    </div>
  }
</div>
